import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { SingleUseTokensListPage } from '@/components/user/SingleUseTokensListPage';

export default function SingleUseTokensPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <SingleUseTokensListPage />
            </MainLayout>
        </ProtectedRoute>
    );
}
